import { useCallback } from "react"
import { useMutation } from "urql"

import { PutAwayPalletsDocument } from "@/graphql/codegen/graphql"
import type { GoodsReceiptPallet, PutAwayUpdateInput } from "@/graphql/codegen/graphql"

interface UsePutAwayPalletsReturn {
  putAwayPallets: (palletIds: string[]) => Promise<{ success: boolean; error?: string; data?: GoodsReceiptPallet[] }>
  loading: boolean
}

export const usePutAwayPallets = (): UsePutAwayPalletsReturn => {
  const [{ fetching }, executeMutation] = useMutation(PutAwayPalletsDocument)

  const putAwayPallets = useCallback(
    async (palletIds: string[]) => {
      const input: PutAwayUpdateInput[] = palletIds.map((palletId) => ({
        goodsReceiptPalletId: palletId,
        isStored: true,
      }))

      const result = await executeMutation({ input })

      if (result.error) {
        return {
          success: false,
          error: result.error.message,
        }
      }

      if (result.data?.goodsReceipt.putAway.__typename === "PutAwayUpdateFailure") {
        return {
          success: false,
          error: result.data.goodsReceipt.putAway.error,
        }
      }

      return {
        success: true,
        data: result.data?.goodsReceipt.putAway.goodsReceiptPallets as GoodsReceiptPallet[],
      }
    },
    [executeMutation]
  )

  return {
    putAwayPallets,
    loading: fetching,
  }
}
